import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,

  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { useRef, useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import Select from "react-select";
import { toast } from "react-toastify";
import { postBanner, updateBanner, getBannerById } from "../../MyApi/banner";
import EnhancedSearchStore from "../../Components/UI/enhancedstoresearch";
import ArrowTop from "../../Components/Common/svg/arrowtop";
import { getCities } from "../../MyApi/admin/cities";
import { getProducts } from "../../MyApi/product";
import Button from "../../Components/UI/buttonGlobal";
import i18next from "i18next";
import LangSelectModal from "../../Components/UI/langselectmodal";
import SkeletonWrapper from "../../Components/UI/skeletonWrapper";

const BannerModal = ({
  isOpen,
  toggle,  
  refetch,
  mode = "create",
  bannerId = null,
}) => {   
  const isEdit = mode === "edit";
  const isShow = mode === "show";
  const lang =i18next.language
  const [selectedLangCode,setSelectedLangCode]=useState(lang)
  const { data: bannerData, isLoading: bannerLoading } = useQuery(
    ["banner", bannerId ,selectedLangCode],
    () => getBannerById(bannerId ,selectedLangCode),
    {
      enabled: (isEdit || isShow) && !!bannerId,
    }
  );

  const banner = bannerData?.data?.banner ||[];
  const [formData, setFormData] = useState({
    title: "",
    link: "",
    image: "",
    bannerable_type: "store",
    bannerable_id: "",
    start_date: "",
    end_date: "",
    is_active: 1,
    city_id: "",
  });
  const { data } = useQuery("getcites", () => getCities());
  const { data: productsData } = useQuery("getproducts", () => getProducts());
  const products = productsData?.data?.data || [];
  const cites = data?.data.cities || [];

  useEffect(() => {
    if ((isEdit || isShow) && banner) {
      setFormData({
        title: banner.title || "",  
        link: banner.link || "",
        image: banner.image || "",
        bannerable_type: banner.bannerable_type || "store",
        bannerable_id: banner.bannerable_id || "",
        start_date: banner.start_date ? banner.start_date.split(" ")[0] : "",
        end_date: banner.end_date? banner.end_date.split(" ")[0] : "",
        is_active: banner.is_active ? 1 : 0,
        city_id: banner.city?.id || "",
      });
    } else if (mode === "create") {
      setFormData({
        title: "",
        link: "",
        image: "",
        bannerable_type: "store",
        bannerable_id: "",
        start_date: "",
        end_date: "",
        is_active: 1,
        city_id: "",
      });
    }
  }, [isEdit, isShow, bannerData, isOpen, mode]);
  const handleChange = (e) => {
    const { name, value, type, files } = e?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSelect2Change = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      city_id: selectedOption?.id || "",
    }));
  };
  const handleProductChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      bannerable_id: selectedOption?.id || "",
    }));
  };
  const logoInputRef = useRef();

  const createBannerMutation = useMutation({
    mutationFn: (postData) => postBanner(postData),
    onSuccess: () => {
      toast.success("Banner created successfully");
      refetch();
      toggle();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const updateBannerMutation = useMutation({
    mutationFn: (postData) => updateBanner(bannerId, postData),
    onSuccess: () => {
      toast.success("Banner updated successfully");
      refetch();
      toggle();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const handleUploadClick = () => {
    if (logoInputRef.current) {
      logoInputRef.current.click();
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const sendData = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if(key ==="image" && !(value instanceof File ) ){
        return
      }
      if (value !== null && value !== "") {
        sendData.append(key, value);
      }
    });
    if (isEdit) {
      sendData.append("lang",selectedLangCode)
      sendData.append("_method","PUT")
      updateBannerMutation.mutate(sendData);
    } else {
      createBannerMutation.mutate(sendData);
    }
  };
  const setStoreId = (id) => {
    setFormData((prev) => ({ ...prev, bannerable_id: id }));
  };
 
  const modalTitle = isShow
    ? "عرض البانر"
    : isEdit
    ? "تعديل البانر"
    : "إضافة بانر";

    const handleChangeLanguage =(e)=>{
setSelectedLangCode(e.target.value)
    }

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={true} centered size="lg" className="add">
      <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>

      <Form onSubmit={isShow ? (e) => e.preventDefault() : handleSubmit}>
        <ModalBody>
         {isEdit && <LangSelectModal handleChange={handleChangeLanguage} selectedLangCode={selectedLangCode}/>}
          <FormGroup>
            <Label>الاسم</Label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
              <Input
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
                disabled={isShow}
              />
            </SkeletonWrapper>
          </FormGroup>
          <div
            className="flex-grow-1 border rounded-4 text-center p-4 upload-box mt-4"
            onClick={handleUploadClick}
            style={{ cursor: "pointer", minWidth: "250px" }}
                      disabled={isShow}
          >
  
            {!isShow ? <>          <ArrowTop /> <h6 className="fw-bold mb-1">صورة البانر</h6>
            <p className="text-muted small mb-0">
              (JPG / PNG) ارفع صورة بجودة عالية
            </p>
            <p className="text-muted small mb-0">الأبعاد 1:1</p></> :null }
            {formData.image && (
              <img
                src={
                  formData.image instanceof File
                    ? URL.createObjectURL(formData.image)
                    : formData.image
                }
                alt=""  
                width={100}
                height={100}
              />
            )}
            <input
              type="file"
              name="image"
              accept="image/png, image/jpeg"
              hidden
              ref={logoInputRef}
              onChange={handleChange}
              disabled={isShow}
            />

            {formData.image && (
              <p className="mt-2 text-success small">{formData.image.name}</p>
            )}
          </div>

          <FormGroup>
            <Label>الرابط</Label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
              <Input
                name="link"
                value={formData.link}
                onChange={handleChange}
                disabled={isShow}
              />
            </SkeletonWrapper>
          </FormGroup>

          <FormGroup>
            <Label> النوع </Label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
              <Input
                type="select"
                name="bannerable_type"
                value={formData.bannerable_type}
                onChange={handleChange}
                disabled={isShow}
              >
                <option value="store">متجر</option>
                <option value="product">منتج</option>
              </Input>
            </SkeletonWrapper>
          </FormGroup>

          {formData.bannerable_type === "store" ? (
            <div>
              {" "}
              <label htmlFor="" className="form-label">
                المتاجر
              </label>{" "}
              <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
                <EnhancedSearchStore
                  setStoreId={setStoreId}
                  value={
                    (isEdit || isShow) && banner?.bannerable_id
                      ? { id: banner.bannerable?.id, name: banner?.bannerable?.name }
                      : null
                  }
                  disabled={isShow}
                />
              </SkeletonWrapper>{" "}
            </div>
          ) : (
            <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
              <Select
                name="products"
                options={products}
                value={
                  products.find((p) => p.id === formData.bannerable_id) || null
                }
                getOptionLabel={(e) => e.name}
                getOptionValue={(e) => e.id}
                onChange={handleProductChange}
                isDisabled={isShow}
              ></Select>
            </SkeletonWrapper>
          )}

          <div className="d-flex gap-3 ">
            <FormGroup className="flex-fill">
              <Label> تاريخ البداية</Label>
              <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
                <Input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  disabled={isShow}
                />
              </SkeletonWrapper>
            </FormGroup>

            <FormGroup className="flex-fill">
              <Label> تاريخ الانتهاء</Label>
              <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
                <Input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  disabled={isShow}
                />
              </SkeletonWrapper>
            </FormGroup>
          </div>

          <FormGroup>
            <Label> المدينة</Label>
            <SkeletonWrapper isLoading={(isEdit || isShow) && bannerLoading}>
              <Select
                name="cites"
                options={cites}
                value={cites.find((c) => c.id === formData.city_id) || null}
                onChange={handleSelect2Change}
                getOptionLabel={(e) => e.name}
                getOptionValue={(e) => e.id}
                isDisabled={isShow}
              ></Select>
            </SkeletonWrapper>
          </FormGroup>

          <FormGroup switch>
            <label class="switch">
              <input
                type="checkbox"
                disabled={isShow}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    is_active: e.target.checked ? 1 : 0,
                  }))
                }
                checked={formData.is_active === 1}
              />
              <span className="slider round"></span>
            </label>
            <Label check>نشط</Label>
          </FormGroup>
        </ModalBody>
         {!isShow ? <ModalFooter>
          <div className="col-2">
           <Button
            className="btn-primary "
             onClick={handleSubmit}
            label={"حفظ"}
            isLoading={createBannerMutation.isLoading ||updateBannerMutation.isLoading}
            disabled={createBannerMutation.isLoading ||updateBannerMutation.isLoading}
          >
        
          </Button>
          </div>
       
          <button className="btn btn-white" type="button" onClick={toggle}>
            إلغاء
          </button>
        </ModalFooter> :null }

      </Form>
    </Modal>
  );
};

export default BannerModal;
